import logos from '../../assets/images/loghi/logos.svg';
import ellipse from '../../assets/images/background/ellipse.png';
import './Footer.css';

const Footer = () => {
  return (
    <footer
      className='d-flex justify-content-center align-items-center'
      id='footer'
      role='contentinfo'
      aria-label='Page footer'
    >
      <img alt='' role='presentation' className='ellipse-bg' src={ellipse} />

      <div className='footer-content'>
        <img
          alt='Partner logos including MOOD and thefaculty'
          src={logos}
          className='footer-logos'
        />

        <p className='footer-text'>
          Iniziativa realizzata da MOOD e thefaculty, con il patrocinio del
          Ministero dell’Università e della Ricerca
        </p>
      </div>
    </footer>
  );
};

export default Footer;
